(() => {
  'use strict';

  function initializeProduct(section) {
    if (section.dataset.productInitialized === 'true') return;
    section.dataset.productInitialized = 'true';
    const select = section.querySelector('[data-variant-select]');
    const image = section.querySelector('[data-product-image]');
    const initialImage = image ? { source: image.currentSrc || image.src, alt: image.alt } : null;
    const addButton = section.querySelector('[data-product-add]');
    if (addButton) {
      const available = section.dataset.productAvailable === 'true';
      addButton.disabled = !available;
      addButton.textContent = available ? 'Add to bag' : 'Sold out';
    }

    function updateImage(source, alt) {
      if (!image || !source) return;
      image.removeAttribute('srcset');
      image.src = source;
      image.alt = alt || '';
    }

    section.querySelectorAll('[data-product-thumbnail]').forEach((thumbnail) => {
      thumbnail.addEventListener('click', (event) => {
        if (!image || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        updateImage(thumbnail.dataset.image, thumbnail.dataset.imageAlt);
      });
    });

    if (!select) return;
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      const available = option.dataset.available === 'true';
      const availability = section.querySelector('[data-product-availability]');
      const price = section.querySelector('[data-product-price]');
      const compare = section.querySelector('[data-product-compare]');
      const compareValue = section.querySelector('[data-product-compare-value]');
      const unitPrice = section.querySelector('[data-product-unit-price]');
      const unitPriceValue = section.querySelector('[data-product-unit-price-value]');
      const quantity = section.querySelector('[data-product-quantity]');
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? 'Add to bag' : 'Sold out';
      }
      if (availability) availability.textContent = available ? 'Available' : 'Sold out';
      if (price) price.textContent = option.dataset.price || '';
      if (compare) compare.hidden = !option.dataset.compare;
      if (compareValue) compareValue.textContent = option.dataset.compare || '';
      if (unitPrice) unitPrice.hidden = !option.dataset.unitPrice;
      if (unitPriceValue) unitPriceValue.textContent = option.dataset.unitPrice || '';
      if (quantity) {
        const minimum = Number(option.dataset.min) || 1;
        const increment = Number(option.dataset.step) || 1;
        const maximum = Number(option.dataset.max) || null;
        quantity.min = String(minimum);
        quantity.step = String(increment);
        if (maximum) quantity.max = String(maximum);
        else quantity.removeAttribute('max');
        let value = Number(quantity.value) || minimum;
        value = Math.max(minimum, minimum + Math.floor((value - minimum) / increment) * increment);
        if (maximum && value > maximum) value = minimum + Math.floor((maximum - minimum) / increment) * increment;
        quantity.value = String(value);
      }
      updateImage(option.dataset.image || initialImage?.source, option.dataset.imageAlt || initialImage?.alt);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });
  }

  function initialize(root) {
    root.querySelectorAll('[data-product-section]').forEach(initializeProduct);
  }

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
